import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import ValidationError from "~/Components/Forms/ValidationError";
import { toast } from 'react-toastify';

const AdminAddInventory = ({ event, children, onChange, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);

    const [form, setForm] = useState({
        package_id: null,
        wave_id: null,
        allocation: 0,
    });

    const loadWaves = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/waves',)
            .then(res => setWaves(res.data));
    };

    const loadPackages = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/packages',)
            .then(res => setPackages(res.data));
    };

    useEffect(loadWaves, [event]);
    useEffect(loadPackages, [event]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = { ...form, [name]: value };

        setForm(formData);
    };

    const handleSubmit = () => {
        toast.promise(
            adminHttp.post('/events/' + event.id + '/inventories', form),
            {
                pending: 'Adding Inventory...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'New inventory added'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (
        <>
            <button {...rest} onClick={handleShow}>{children}</button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Inventory</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving tickets!"}
                        </div>
                    )}

                    <div className="form-group required">
                        <label>Wave</label>

                        <select name="wave_id"
                            defaultValue={form.wave_id}
                            onChange={e => handleChange(e)}
                            className="form-control">

                            <option value={0}>- Select -</option>

                            {waves.map(wave => (
                                <option key={wave.id} value={wave.id}>{wave.name}</option>
                            ))}
                        </select>

                        <ValidationError errors={error?.errors} name="wave_id" />

                    </div>

                    <div className="form-group required">
                        <label>Package</label>

                        <select name="package_id"
                            defaultValue={form.package_id}
                            onChange={e => handleChange(e)}
                            className="form-control">

                            <option value={0}>- Select -</option>

                            {packages.map(p => (
                                <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                        </select>

                        <ValidationError errors={error?.errors} name="package_id" />

                    </div>

                    <div className="form-group required">
                        <label className="d-block">Allocation</label>

                        <input
                            onChange={handleChange}
                            value={form.allocation}
                            name="allocation"
                            className="form-control" />

                        <ValidationError errors={error?.errors} name="allocation" />
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminAddInventory);
